module.exports = __webpack_public_path__ + "img/aqtobe5.5349963a.jpg";